module.exports = __webpack_public_path__ + "static/img/style3.98a6ad7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/title/style3.png
// module id = tRHt
// module chunks = 0